import ErrorCard from 'commons/card/ErrorCard';
import LoadingCard from 'commons/card/LoadingCard';
import UrlFormatter from 'commons/filters/UrlFormatter';
import * as fdates from 'commons/models/dates';
import EmptyResult from 'commons/status/EmptyResult';
import * as r from 'constants/routes';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CustomGantt from './components/CustomGantt';
import CreateProjectModal from './components/modals/CreateProjectModal';
import { useNavigate } from 'react-router-dom';
import { useAddProjectMutation, useGetBannieresQuery, useGetCampagneTypesQuery, useGetProjectQuery } from '../../redux/api/cache';

export default function ProjectContainer(props) {
  const [categorie] = useState({ data: [] });
  const navigate = useNavigate();
  const location = useLocation();
  const [addProject] = useAddProjectMutation();

  const dates = () => {
    if (localStorage.getItem(r.SEARCH_QUERY_PROJECT) !== null) {
      let from = query
        .split('&')
        .find((param) => param.includes('dtDeb'))
        .split('=')[1]
        .split('/');
      let to = query
        .split('&')
        .find((param) => param.includes('dtFin'))
        .split('=')[1]
        .split('/');
      return [
        new Date(parseInt(from[2]), parseInt(from[1]) - 1, parseInt(from[0])),
        new Date(parseInt(to[2]), parseInt(to[1]) - 1, parseInt(to[0])),
      ];
    }
    var dtDeb = new Date();
    var dtFin = new Date(new Date().setDate(new Date().getDate() + 31));
    return [dtDeb, dtFin];
  };

  const { data: bannieres } = useGetBannieresQuery();

  const { data: campagneTypes } = useGetCampagneTypesQuery();

  let tempData = [];

  if (campagneTypes !== undefined && campagneTypes.data !== undefined) {
    campagneTypes?.data.forEach(type => {
      let verif = false;
      tempData.forEach(data => {
        if (data["camptyp_categ"] === type.camptyp_categ) {
          verif = true;
        }
      });

      if (!verif) {
        tempData.push({ camptyp_categ: type.camptyp_categ });
      }
    });
  }

  categorie.data = tempData;

  const [createModal, setCreateModal] = useState(false);
  const [query, setQuery] = useState(
    localStorage.getItem(r.SEARCH_QUERY_PROJECT) === null
      ? `dtDeb=${fdates.dateQueryFormat(
        dates()[0]
      )}&dtFin=${fdates.dateQueryFormat(dates()[1])}&`
      : localStorage.getItem(r.SEARCH_QUERY_PROJECT)
  );
  const { data: projets = {}, isError, isLoading } = useGetProjectQuery({ query });

  const create = async (values) => {
    let result = await addProject(values).unwrap();
    if (result.success) {
      navigate(location.pathname + '/Projets/' + result.data[0].camp_seq);
    }
  };

  return (
    <Fragment>
      <UrlFormatter
        canAdd={true}
        today={true}
        title="Projets"
        titleButton={'Créer un nouveau projet'}
        dates={[
          { label: 'Début', key: 'dtDeb' },
          { label: 'Fin', key: 'dtFin' },
        ]}
        inputs={[{ label: 'Numéro', key: 'camp_num' }]}
        dropDowns={[
          {
            label: 'Bannière',
            key: 'maggrp_cd',
            values: bannieres?.data,
          },
          {
            label: 'Categorie',
            key: 'camptyp_categ',
            values: categorie?.data,
          },
          {
            label: 'Type',
            key: 'camptyp_cd',
            values: campagneTypes?.data,
          },
        ]}
        defeault={{
          dtDeb: dates()[0],
          dtFin: dates()[1],
          camptyp_categ: 'Tous',
          camptyp_cd: 'Tous',
          maggrp_cd: 'Tous',
        }}
        updateQuery={(query) => {
          localStorage.setItem(r.SEARCH_QUERY_PROJECT, query);
          setQuery(query);
        }}
        create={() => setCreateModal(!createModal)} />
      {isLoading && !isError && <LoadingCard title="Recherche..." />}
      {!isLoading && isError && <ErrorCard title="Projet" />}
      {!isLoading && !isError && projets.data && projets?.data?.length !== 0 && (
        <CustomGantt
          navigate={navigate}
          location={location}
          path={props.path}
          title={`Projets (${projets?.data?.length} trouvés)`}
          data={projets} />
      )}
      {!isLoading && !isError && projets?.data?.length === 0 && (
        <EmptyResult
          title={'Aucun projet trouvé'}
          message={' veuillez affiner votre recherche'} />
      )}
      {createModal && (
        <CreateProjectModal
          create={create}
          toggleDialog={() => {
            setCreateModal(!createModal);
          }} />
      )}
    </Fragment>
  );
}

ProjectContainer.propTypes = {
  path: PropTypes.string,
};
